import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AgreeOn } from 'src/app/models/agree-on';

@Component({
  selector: 'app-agree-dialog',
  templateUrl: './agree-dialog.component.html',
  styleUrls: ['./agree-dialog.component.css']
})
export class AgreeDialogComponent implements OnInit {

  title: string = "";
  textToAgree: string = "";

  constructor(
    public dialogRef: MatDialogRef<AgreeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AgreeOn) {
      if(data){
        this.title = data.title;
        this.textToAgree = data.text;
      }
    }

  onNoClick(): void {
    this.dialogRef.close(true);
  }

  ngOnInit(): void {
  }

}
